import React, { useState, useEffect, useRef } from 'react';
import { getRole, logout } from "../services/auth";
import { useNavigate, Link } from "react-router-dom";
import axios from 'axios';

const TELEFONO_NUM = "56956482185";
const TELEFONO_DISPLAY = "+56 9 5648 2185";
const TELEFONO2_NUM = "56979974989";
const TELEFONO2_DISPLAY = "+56 9 7997 4989";
const EMAIL_CONTACTO = "conctacto@hangarsupply.cl";

function TelefonoInteractivo() {
  const [open, setOpen] = useState(false);
  const [copiado, setCopiado] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const copiar = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(TELEFONO_DISPLAY);
    } else {
      const el = document.createElement("textarea");
      el.value = TELEFONO_DISPLAY;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopiado(true);
    setTimeout(() => { setCopiado(false); setOpen(false); }, 1200);
  };

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <span
        onClick={() => setOpen(o => !o)}
        style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
      >
        📞 {TELEFONO_DISPLAY}
      </span>
      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 8px)", left: 0,
          backgroundColor: "#fff", color: "#333", borderRadius: 8,
          boxShadow: "0 4px 16px rgba(0,0,0,0.18)", zIndex: 300, minWidth: 190,
          overflow: "hidden", border: "1px solid #e5e7eb",
        }}>
          <a href={`tel:+${TELEFONO_NUM}`} style={opSt} onClick={() => setOpen(false)}>
            📞 Llamar
          </a>
          <a href={`https://wa.me/${TELEFONO_NUM}`} target="_blank" rel="noreferrer" style={opSt} onClick={() => setOpen(false)}>
            💬 WhatsApp
          </a>
          <button onClick={copiar} style={{ ...opSt, border: "none", background: copiado ? "#f0fdf4" : "none", cursor: "pointer", width: "100%", textAlign: "left", font: "inherit", color: copiado ? "#16a34a" : "#333" }}>
            {copiado ? "✔ Copiado" : "📋 Copiar número"}
          </button>
        </div>
      )}
    </div>
  );
}

const opSt = {
  display: "block", padding: "11px 16px", textDecoration: "none",
  color: "#333", fontSize: 14, borderBottom: "1px solid #f0f0f0",
};

function Header({ setResultadosBusqueda }) {
  const [terminoBusqueda, setTerminoBusqueda] = useState('');
  const role = getRole();
  const navigate = useNavigate();
  const API_URL = `${process.env.REACT_APP_API_URL}/api`;

  const handleBuscarProducto = async () => {
    const termino = terminoBusqueda.trim();
    if (!termino) return;
    try {
      const res = await axios.get(`${API_URL}/busqueda/buscar/${termino}`);
      if (!res.data || res.data.length === 0) {
        alert(`No se encontraron productos para "${termino}"`);
        setResultadosBusqueda([]);
      } else {
        setResultadosBusqueda(res.data);
      }
    } catch (error) {
      alert('Error al realizar la búsqueda. Intente nuevamente.');
    }
  };


  return (

    <div className="App">
      <header className="top-bar">
        <div className="contact-info">
          <TelefonoInteractivo />
          <a href={`tel:+${TELEFONO2_NUM}`} style={{ whiteSpace: "nowrap", textDecoration: "none", color: "inherit" }}>
            📞 {TELEFONO2_DISPLAY}
          </a>
          <a href={`mailto:${EMAIL_CONTACTO}`} style={{ whiteSpace: "nowrap", textDecoration: "none", color: "inherit" }}>
            ✉️ {EMAIL_CONTACTO}
          </a>
        </div>
        <div className="top-links">
          <Link to="/quienes-somos">¿Quiénes Somos?</Link>
          <Link to="/mision-vision">Misión &amp; Visión</Link>
          <a href="/register">Registrate</a>
          <Link to="/contacto">Contacto</Link>
          {role === "CLIENT" && (
            <>
              <Link to="/mi-perfil">Mi Perfil</Link>
              <Link to="/mis-compras">Mis Compras</Link>
              <Link to="/mis-direcciones">Mis Direcciones</Link>
            </>
          )}
        </div>
      </header>
    
      <div className="search-bar">
        <img
            src="/logo.png?v=2"
            alt="Hangar Supply Logo"
            className="header-logo"
        />
        <input
          type="text"
          placeholder="BUSCAR PRODUCTO"
          value={terminoBusqueda}
          onChange={(e) => setTerminoBusqueda(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleBuscarProducto()}
        />
        <button onClick={handleBuscarProducto}>🔍</button>

      {/*
      <section>
        <h2>Buscar Producto</h2>
        <input
          type="text"
          placeholder="Buscar por nombre o categoría"
          value={terminoBusqueda}
          onChange={(e) => setTerminoBusqueda(e.target.value)}
        />
        <button onClick={handleBuscarProducto}>Buscar</button>

        {resultadosBusqueda.length > 0 && (
          <>
            <h3>Resultados</h3>
            <table border="1" cellPadding="8" cellSpacing="0">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Precio</th>
                  <th>Stock</th>
                  <th>Categoría</th>
                  <th>Unidad Medida</th>
                </tr>
              </thead>
              <tbody>
                {resultadosBusqueda.map(p => (
                  <tr key={p.id}>
                    <td>{p.nombre}</td>
                    <td>{p.descripcion}</td>
                    <td>{p.precio}</td>
                    <td>{p.stock}</td>
                    <td>{p.categoria}</td>
                    <td>{p.unidadMedida}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </section>
*/}
      {role === "ADMIN" && (
        <div className="admin-menu">
          <Link to="/admin">
            <button className="login-btn">Productos</button>
          </Link>
          <Link to="/categorias/nueva">
            <button className="login-btn">Categorías</button>
          </Link>
          <Link to="/estadisticas">
            <button className="login-btn">Estadísticas</button>
          </Link>
          <Link to="/historial-venta">
            <button className="login-btn">Ventas</button>
          </Link>
        </div>
      )}

      {role ? (
        <button className="login-btn" onClick={logout}>Logout</button>
      ) : (
        <button className="login-btn" onClick={() => window.location.href = "/login"}>
          Login
        </button>
      )}

      </div>

    </div>
  );
}

export default Header;